import React from 'react';
import { useLocation } from 'react-router';
import './styles.css';
//import { Rodape } from '../../components/Rodape';
import imgErr from '../../../src/img/404.svg';
import { Image } from '../../components/Image';

export const Page404 = () => {
  const search = useLocation().search;
  const message = new URLSearchParams(search).get('message');

  return (
    <>
      <div style={{ backgroundColor: '#e3262e', minHeight: '4.6875rem' }}>
        <h4 className="title-category" style={{ color: 'white', textAlign: 'center', padding: 17 }}>
          Ops... Ocorreu um erro
        </h4>
      </div>
      <div id="top"></div>
      <div id="categorias"></div>
      <div
        className="container padTop20"
        style={{
          position: 'relative',
          height: 'auto',
          textAlign: 'center',
          margin: 'auto',
        }}
      >
        <Image srcLocal={imgErr} className="error-svg padTop20" alt="error" />
        <h1 style={{ marginTop: '30px' }}> {message}</h1>
      </div>
    </>
  );
};
